module.exports = __webpack_public_path__ + "img/sixpackcarrier100.73f1eb96.jpg";